// First: before any module builds a schema.
import "./zod-config.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n/i18n.ts";
import { App } from "./App.tsx";
import "./index.css";
import { RootBoundary, rootErrorHooks } from "./shell/RootBoundary.tsx";
import { installClientTelemetry } from "./telemetry/client-telemetry.ts";

// Client telemetry (openspec change `client-telemetry`): queued from the first moment, sent
// only once `/api/me` (or the signed-out session answer) says the tenant reports.
installClientTelemetry();

const queryClient = new QueryClient();
const root = document.getElementById("root");
if (!root) {
  throw new Error("#root not found");
}

// Render errors, from React's root hooks: RootBoundary shows the fallback page (#337) and React
// reports what it caught through onCaughtError, anything else through onUncaughtError.
createRoot(root, rootErrorHooks()).render(
  <StrictMode>
    <RootBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </RootBoundary>
  </StrictMode>,
);
